export const DRAWER_WIDTH = 350;
export const DRAWER_WIDTH_TABLET = 180;
export const TABLE_PAGE_INIT = '1';
export const TABLE_PAGE_SIZE = '10';
export const MAX_FILE_SIZE = 5 * 1024 * 1024;
